import React, {useState} from "react";
import {ControlledMenu, MenuItem, useMenuState} from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import {useTranslation} from "react-i18next";

type MenuStateProps = ReturnType<typeof useMenuState>[0];

export function useListContextMenu() {
    const [menuProps, toggleMenu] = useMenuState();
    const [anchorPoint, setAnchorPoint] = useState({x: 0, y: 0});
    const [targetId, setTargetId] = useState<string | null>(null);

    const onContextMenu = (id: string, x: number, y: number) => {
        setAnchorPoint({x, y});
        setTargetId(id);
        toggleMenu(true);
    };

    const close = () => toggleMenu(false);

    return {menuProps, anchorPoint, targetId, onContextMenu, close};
}

export function openInNewTab(path: string) {
    window.open(path, "_blank", "noopener,noreferrer");
}

interface ListItemContextMenuProps {
    menuProps: MenuStateProps;
    anchorPoint: {x: number; y: number};
    onClose: () => void;
    onOpen: () => void;
    onOpenInNewTab: () => void;
    newTabLabelKey?: string;
    children?: React.ReactNode;
}

export const ListItemContextMenu: React.FC<ListItemContextMenuProps> = ({
                                                                            menuProps,
                                                                            anchorPoint,
                                                                            onClose,
                                                                            onOpen,
                                                                            onOpenInNewTab,
                                                                            newTabLabelKey = "open_in_new_tab",
                                                                            children
                                                                        }) => {
    const {t} = useTranslation();
    return (
        <ControlledMenu {...menuProps} anchorPoint={anchorPoint}
                        onClose={onClose} menuClassName={"context-menu"} portal>
            <MenuItem onClick={onOpen}>{t("open")}</MenuItem>
            <MenuItem onClick={onOpenInNewTab}>{t(newTabLabelKey)}</MenuItem>
            {children}
        </ControlledMenu>
    );
};
